import InfoPanel from './InformationPanel-infoPanel-config.json';
import StatusScreens from './StatusScreenOverlays-statusScreens-config.json';
import LivePoll from './LivePoll-livePoll-config.json';
import Wave from './TwitchWave-twitchWave-config.json';
import ImageOverlay from './ImageOverlay-imageOverlay-config.json';
import FlockToUnlock from './FlocktoUnlock-flockToUnlock-config.json';
import ObjectZapper from './ObjectZapper-objectZapper-config.json';
import ObjectSpawner from './ObjectSpawner-objectSpawner-config.json';

export const WorkspaceConfig = {
    infoPanel: InfoPanel,
    statusScreens: StatusScreens,
    livePoll: LivePoll,
    twitchWave: Wave,
    imageOverlay: ImageOverlay,
    flockToUnlock: FlockToUnlock,
    objectZapper: ObjectZapper,
    objectSpawner: ObjectSpawner,
};
